export default {"src":"/_next/static/media/tips_blue.11574dc2.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};